import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Create from "../views/quote/Create.vue";
import List from "../views/quote/List.vue";
import BuscadorCotizaciones from "../views/quote/Buscador.vue";
import Corp from "../views/quote/Corp.vue";
import CotizadorManual from "../views/quote/CotizadorManual.vue";
import Perfil from "../views/Perfil.vue";
import ParametrosCotizador from "../views/ParametrosCotizador.vue";
import Contabilidad from "../views/Contabilidad.vue";
import RRHHEmpleados from "../views/rrhh/Empleados.vue";
import RRHHExpediente from "../views/rrhh/Expediente.vue";
import RRHHOrganigrama from "../views/rrhh/Organigrama.vue";
import RRHHCalendario from "../views/rrhh/Calendario.vue";
import RRHHMisSolicitudes from "../views/rrhh/MisSolicitudes.vue";
import RRHHAprobaciones from "../views/rrhh/Aprobaciones.vue";
import Catalogos from "../views/configuracion/Catalogos.vue";
import LogsAuditoria from "../views/configuracion/LogsAuditoria.vue";
import KommoClientesSinRespuesta from "../views/kommo/ClientesSinRespuesta.vue";
import CitasAgendar from "../views/citas/AgendarCita.vue";
import CitasCalendario from "../views/citas/Calendario.vue";
import CitasMisCitas from "../views/citas/MisCitas.vue";
import CitasHorario from "../views/citas/HorarioAsesor.vue";
import { useAuth } from "@/composables/useAuth";
import { ROLES } from "@/constants/roles";

const routes = [
  {
    path: "/",
    redirect: "/signin", // 👈 ahora inicia en login
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }, // 👈 protegida
  },
  {
    path: "/quote",
    component: Tables,
    meta: { requiresAuth: true }, // 👈 protegida
    children: [
      {
        path: "create",
        name: "Generar Cotizacion",
        component: Create,
      },
      {
        path: "corp",
        name: "Generar Cotizacion Corporativo",
        component: Corp,
        meta: { requiresRoles: [ROLES.ADMIN, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO] },
      },
      {
        path: "manual",
        name: "Cotizacion Manual",
        component: CotizadorManual,
      },
      {
        path: "list",
        name: "ListCotizaciones",
        component: List,
      },
      {
        path: "buscador",
        name: "BuscadorCotizaciones",
        component: BuscadorCotizaciones,
      }
    ]
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requiresAuth: true },
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
  },
  {
    path: "/parametros-cotizador",
    name: "Parametros Cotizador",
    component: ParametrosCotizador,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
  },
  {
    path: "/configuracion/catalogos",
    name: "ConfiguracionCatalogos",
    component: Catalogos,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
  },
  {
    path: "/kommo/sin-respuesta",
    name: "Clientes sin respuesta",
    component: KommoClientesSinRespuesta,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR, ROLES.RRHH] },
  },
  {
    path: "/configuracion/logs",
    name: "ConfiguracionLogsAuditoria",
    component: LogsAuditoria,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
  },
  {
    path: "/contabilidad",
    name: "Contabilidad",
    component: Contabilidad,
    meta: { requiresAuth: true, requiresRoles: ["admin", "contabilidad"] }, // 👈 admin y contabilidad
  },
  {
    path: "/rrhh/empleados",
    name: "RRHHEmpleados",
    component: RRHHEmpleados,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/empleados/:id",
    name: "RRHHExpediente",
    component: RRHHExpediente,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/mi-expediente",
    name: "RRHHMiExpediente",
    component: RRHHExpediente,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/organigrama",
    name: "RRHHOrganigrama",
    component: RRHHOrganigrama,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/calendario",
    name: "RRHHCalendario",
    component: RRHHCalendario,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/mis-solicitudes",
    name: "RRHHMisSolicitudes",
    component: RRHHMisSolicitudes,
    meta: { requiresAuth: true },
  },
  {
    path: "/rrhh/aprobaciones",
    name: "RRHHAprobaciones",
    component: RRHHAprobaciones,
    meta: { requiresAuth: true },
  },
  {
    path: "/citas/agendar",
    name: "CitasAgendar",
    component: CitasAgendar,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH] },
  },
  {
    path: "/citas/calendario",
    name: "CitasCalendario",
    component: CitasCalendario,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH, ROLES.SUPERVISOR] },
  },
  {
    path: "/citas/mis-citas",
    name: "CitasMisCitas",
    component: CitasMisCitas,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH] },
  },
  {
    path: "/citas/horario",
    name: "CitasHorario",
    component: CitasHorario,
    meta: { requiresAuth: true, requiresRoles: [ROLES.ADMIN, ROLES.ASESOR_LIDER, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.SUPERVISOR, ROLES.RRHH] },
  },
  {
    path: "/perfil",
    name: "Mi Perfil",
    component: Perfil,
    meta: { requiresAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// 🔐 GUARD GLOBAL
// El accessToken vive en cookie httpOnly (no legible desde JS), así que la
// única forma de saber si hay sesión activa es preguntarle a /me. loadUser
// cachea el resultado mientras dure la sesión, así que esto solo pega contra
// el backend en la primera navegación (o tras un logout).
router.beforeEach(async (to, from, next) => {
  const { user, loadUser } = useAuth();
  await loadUser();

  const isAuthenticated = !!user.value;

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next("/signin");
  }

  if ((to.path === "/signin" || to.path === "/") && isAuthenticated) {
    return next("/dashboard");
  }

  // 👑 Rutas solo para admin
  if (to.meta.requiresAdmin && user.value?.role !== "admin") {
    return next("/dashboard");
  }

  // 🔒 Rutas restringidas a un conjunto de roles
  if (to.meta.requiresRoles && !to.meta.requiresRoles.includes(user.value?.role)) {
    return next("/dashboard");
  }

  next();
});

export default router;